import { filtersObjectFromUrl } from '@common/utils/search-url-generator';

import { DEFAULT_FILTERS } from '../constants';

import { getSortingName } from './sorting';

export const adaptFilters = (filters, sortingAlgorithm) => {
  const sortBy = getSortingName(filters.sortBy, sortingAlgorithm);

  return {
    bathrooms: filters['bathrooms[]'],
    bed: filters.bed,
    budget: filters.budget,
    features: filters['features[]'],
    moveIn: filters['move-in'],
    moveOut: filters['move-out'],
    flexibleMoveIn: filters.flexibleMoveIn,
    flexibleMoveOut: filters.flexibleMoveOut,
    topology: filters['topology[]'],
    type: filters['type[]'],
    page: filters.page,
    instantBooking: filters.instantBooking,
    ids: filters['ids[]'],
    sortBy,
    verified: filters.verified,
    areaId: filters['areaId[]']
  };
};

export const adaptFiltersToUrl = (filters, sortingAlgorithm) => {
  const sortBy = getSortingName(filters.sortBy, sortingAlgorithm);

  return { ...filters, sortBy };
};

export const getInitialFilters = originalUrl => ({
  ...DEFAULT_FILTERS,
  ...filtersObjectFromUrl(originalUrl)
});

export const getDefaultFilters = () => DEFAULT_FILTERS;

export default {
  adaptFilters,
  adaptFiltersToUrl,
  getInitialFilters,
  getDefaultFilters
};
